import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core';
import FormContainer from '../..';
import fieldSelection from '..';
import Button from '../../../Button';

const useStyles = makeStyles(theme => ({
  buttonContainer: {
    display: 'flex',
    justifyContent: 'center',
    marginTop: '3rem',

    '& > button': {
      marginRight: '1rem',
    },
  },
  popupContainer: {
    padding: '2rem',
    background: theme.palette.background.default,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    justifyContent: 'space-between',
  },
}));

const Form = ({
  closeForm,
  initialValues,
  onSubmit,
  onChange,
  validationSchema,
  enableReinitialize,
  size = 'auto',
  formInfo,
  saveHoverText,
  note,
  fields,
  submitButtonText = 'Select',
}) => {
  const classes = useStyles();
  return (
    <FormContainer
      hideFormHeader
      onClickClose={closeForm}
      remarks="required_label"
      initialValues={initialValues}
      onSubmit={onSubmit}
      onChange={onChange}
      validationSchema={validationSchema}
      enableReinitialize={enableReinitialize}
      size={size}
      formInfo={formInfo}
      saveHoverText={saveHoverText}
      note={note}
    >
      {props => {
        return (
          <div className={classes.popupContainer}>
            {fields.map(item => {
              return fieldSelection({ item, key: item.field, props });
            })}
            <section className={classes.buttonContainer}>
              <Button
                type="button"
                text="Cancel"
                onClick={closeForm}
                size="l"
                color="secondary"
                outline={true}
              />
              <Button
                type="submit"
                onClick={props.handleSubmit}
                text={submitButtonText}
                size="l"
                color="primary"
              />
            </section>
          </div>
        );
      }}
    </FormContainer>
  );
};

Form.propTypes = {
  closeForm: PropTypes.func,
  initialValues: PropTypes.object,
  onSubmit: PropTypes.func,
  onChange: PropTypes.func,
  validationSchema: PropTypes.object,
  enableReinitialize: PropTypes.bool,
  size: PropTypes.string,
  formInfo: PropTypes.string,
  saveHoverText: PropTypes.string,
  note: PropTypes.string,
  fields: PropTypes.array,
  handleSubmit: PropTypes.func,
  submitButtonText: PropTypes.string,
};

export default Form;
